const headers = () => {
  return {
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('dashboard_auth_token')}`
    },
  };
};

export default headers;